import { render, staticRenderFns } from "./toolbar-button.vue?vue&type=template&id=ed4de6c2"
import script from "./toolbar-button.vue?vue&type=script&lang=js"
export * from "./toolbar-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports